import { render, staticRenderFns } from "./Statistics.vue?vue&type=template&id=713ead47&"
import script from "./Statistics.vue?vue&type=script&lang=js&"
export * from "./Statistics.vue?vue&type=script&lang=js&"
import style0 from "./Statistics.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/eric/projects/musical/musical-admin-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('713ead47')) {
      api.createRecord('713ead47', component.options)
    } else {
      api.reload('713ead47', component.options)
    }
    module.hot.accept("./Statistics.vue?vue&type=template&id=713ead47&", function () {
      api.rerender('713ead47', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Statistics.vue"
export default component.exports